<template>
    <div class="table-responsive border-t-2 pb-4 border-blue-600">
        <spinner v-if="dataLoading"></spinner>
        <table v-else class="table table-bordered">
            <thead>
                <tr class="text-center border-t bg-tan-200">
                    <th style="min-width: 8rem;" class="print:hidden">
                        <div class="px-2 py-1 period-buttons">
                            <span @click="changeActive('daily')" :class="{active: active === 'daily'}" class="period-button btn btn-chart-period btn-xs btn-shadow-none">D</span>
                            <span @click="changeActive('weekly')" :class="{active: active === 'weekly'}" class="period-button btn btn-chart-period btn-xs btn-shadow-none">W</span>
                            <span @click="changeActive('monthly')" :class="{active: active === 'monthly'}" class="period-button btn btn-chart-period btn-xs btn-shadow-none">M</span>
                        </div>
                    </th>
                    <th><div class="px-2 py-1">{{ getYearLabelText() }} Year Values</div></th>
                    <th><div class="px-2 py-1">High</div></th>
                    <th><div class="px-2 py-1">50% Value</div></th>
                    <th><div class="px-2 py-1">Low</div></th>
                    <!-- <th><div class="px-2 py-1">Trend</div></th> -->
                    <!-- <th><div class="px-2 py-1">Entry Price</div></th> -->
                    <!-- <th><div class="px-2 py-1">Ranking</div></th> -->
                </tr>
            </thead>
            <tbody>
                <tr class="text-center bg-white">
                    <td class="print:hidden"></td>
                    <td>
                        <span class="font-bold">{{ quotes.raw.contractName || quotes.symbolName }}</span>
                    </td>
                    <td>
                        <span class="font-bold">{{ quotes[fields['highPrice']] }}</span>
                        ({{ quotes[fields['highDate']] }})
                    </td>
                    <td>
                        <span class="font-bold">{{ fiftyPercent }}</span>
                    </td>
                    <td>
                        <span class="font-bold">{{ quotes[fields['lowPrice']] }}</span>
                        ({{ quotes[fields['lowDate']] }})
                    </td>
                    <!-- <td>
                        <span :class="getClass(quotes[fields['signal']])" class="font-bold">
                            {{ quotes[fields['signal']] }}
                        </span>
                    </td> -->
                    <!-- <td>
                        <span class="font-bold">{{ quotes[fields['entry']] }}</span>
                        ({{ quotes[fields['days']] }} {{ getIntervalText() | pluralize(quotes[fields['days']]) }})
                    </td> -->
                    <!-- <td>
                        <span :class="getClass(quotes[fields['signal']])" class="font-bold">{{ quotes[fields['direction']] }}</span>
                    </td> -->
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue';
import formatPrice from '@barchart/marketdata-api-js/lib/utilities/format/price';

const props = defineProps({
    symbol: {
        type: String,
        required: true
    }
});

const active = ref('daily');
const dataLoading = ref(true);
const quotes = ref({});
const cache = ref({
    daily: null,
    weekly: null,
    monthly: null
});

const fieldMap = ref({
    daily: {
        highPrice : 'highPrice1y',
        highDate : 'highDate1y',
        lowPrice : 'lowPrice1y',
        lowDate : 'lowDate1y',
        signal : 'trendSpotterSignal',
        entry : 'trendSpotterEntryPrice',
        days : 'daysInTrendSpotter',
        direction : 'trendSpotterDirection',
    },
    weekly: {
        highPrice : 'highPrice5y',
        highDate : 'highDate5y',
        lowPrice : 'lowPrice5y',
        lowDate : 'lowDate5y',
        signal : 'weeklyTrendSpotterSignal',
        entry : 'weeklyTrendSpotterEntryPrice',
        days : 'weeksInTrendSpotter',
        direction : 'weeklyTrendSpotterDirection',
    },
    monthly: {
        highPrice : 'highPrice20y',
        highDate : 'highDate20y',
        lowPrice : 'lowPrice20y',
        lowDate : 'lowDate20y',
        signal : 'monthlyTrendSpotterSignal',
        entry : 'monthlyTrendSpotterEntryPrice',
        days : 'monthsInTrendSpotter',
        direction : 'monthlyTrendSpotterDirection',
    }
});


const fields = computed(() => {
    return fieldMap.value[active.value];
});

const fiftyPercent = computed(() => {
    const fiftyPercent = (quotes.value.raw[fields.value['highPrice']] + quotes.value.raw[fields.value['lowPrice']]) / 2;
    const baseCode = quotes.value.baseCode;
    return formatPrice(fiftyPercent, baseCode, '-', true);
    // return window.Barchart.Utilities.priceFormatter('-', true).format(fiftyPercent, baseCode);
});

const getYearLabelText = () => {
    if (active.value === 'daily') return 1;
    if (active.value === 'weekly') return 5;
    if (active.value === 'monthly') return 20;
};

const getIntervalText = () => {
    if (active.value === 'daily') return 'Day';
    if (active.value === 'weekly') return 'Week';
    if (active.value === 'monthly') return 'Month';
};

const changeActive = (newActive) => {
    if (active.value !== newActive) {
        active.value = newActive;
        getQuotes();
    }
};

const getClass = (value) => {
    if (value === 'Up') {
        return 'text-up';
    } else if (value === 'Down') {
        return 'text-down';
    } else if (value === 'Neutral') {
        return 'text-unch';
    }
};

const getQuotes = () => {
    const route = window.route('api.quotes');

    const params =  {
        symbol: props.symbol,
        fields: Object.values(fields.value).join() + ',unitCode,symbolName,contractName,baseCode'
    };

    if (cache.value[active.value]) {
        quotes.value = cache.value[active.value];
        return;
    }

    dataLoading.value = true;
    axios.post(route, params)
        .then((response) => {
            quotes.value = response.data.data[0];
            cache.value[active.value] = quotes.value;
            dataLoading.value = false;
        }).catch(error => {
            console.error(error);
        });
};

onMounted(() => {
    getQuotes();
});
</script>
